"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureGateEnvironment = exports.FilterTags = exports.FeatureGateProducts = void 0;
const statsig_js_lite_1 = __importStar(require("statsig-js-lite"));
const fetcher_1 = __importDefault(require("./fetcher"));
/**
 * The union of Products will be used to filter appropriate feature gates and experiments
 */
var FeatureGateProducts;
(function (FeatureGateProducts) {
    FeatureGateProducts["Jira"] = "jira";
    FeatureGateProducts["Confluence"] = "confluence";
    FeatureGateProducts["AdminHub"] = "adminhub";
    FeatureGateProducts["Platform"] = "platform";
})(FeatureGateProducts || (exports.FeatureGateProducts = FeatureGateProducts = {}));
/**
 * The intersection of Filter Tags will be used to filter appropriate feature gates and experiments
 */
var FilterTags;
(function (FilterTags) {
    FilterTags["Frontend"] = "frontend";
    FilterTags["Backend"] = "backend";
})(FilterTags || (exports.FilterTags = FilterTags = {}));
var FeatureGateEnvironment;
(function (FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
})(FeatureGateEnvironment || (exports.FeatureGateEnvironment = FeatureGateEnvironment = {}));
const DEFAULT_CLIENT_KEY = 'client-default-key';
class FeatureGates {
    static async initialize(clientOptions, identifiers, customAttributes) {
        if (FeatureGates.initPromise) {
            console.warn('Feature Gates client already initialized');
            return FeatureGates.initPromise;
        }
        FeatureGates.initOptions = clientOptions;
        FeatureGates.initPromise = FeatureGates.init(clientOptions, identifiers, customAttributes);
        return FeatureGates.initPromise;
    }
    static async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        if (FeatureGates.initPromise) {
            console.warn('Feature Gates client already initialized');
            return FeatureGates.initPromise;
        }
        FeatureGates.initOptions = clientOptions;
        FeatureGates.initPromise = FeatureGates.initFromValues(clientOptions, identifiers, customAttributes, initializeValues);
        return FeatureGates.initPromise;
    }
    /**
     * This method updates the user using a network call to fetch the new set of values.
     * @param fetchOptions {FetcherOptions}
     * @param identifiers {Identifiers}
     * @param customAttributes {CustomAttributes}
     */
    static async updateUser(fetchOptions, identifiers, customAttributes) {
        const initializeValuesProducer = () => fetcher_1.default.fetchExperimentValues(fetchOptions, identifiers, customAttributes).then((response) => response.experimentValues);
        await FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
     * This method updates the user given a new set of bootstrap values obtained from one of the server-side SDKs.
     *
     * @param identifiers {Identifiers}
     * @param customAttributes {CustomAttributes}
     * @param initializeValues {Record<string,unknown>}
     */
    static async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        const initializeValuesProducer = () => Promise.resolve(initializeValues);
        await FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    static initializeCalled() {
        return FeatureGates.initPromise != null;
    }
    static checkGate(gateName) {
        return statsig_js_lite_1.default.checkGate(gateName);
    }
    static getExperiment(experimentName) {
        try {
            return statsig_js_lite_1.default.getExperiment(experimentName);
        }
        catch (error) {
            // Log the first occurrence of the error
            if (!FeatureGates.hasGetExperimentErrorOccurred) {
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName,
                    error
                });
                FeatureGates.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new statsig_js_lite_1.DynamicConfig(experimentName, {}, '', {
                time: Date.now(),
                reason: statsig_js_lite_1.EvaluationReason.Error
            });
        }
    }
    static getExperimentCohort(experimentName, defaultValue, fireExperimentExposure = true) {
        const configKey = 'cohort';
        try {
            if (fireExperimentExposure) {
                return statsig_js_lite_1.default.getExperiment(experimentName).get(configKey, defaultValue);
            }
            return statsig_js_lite_1.default.getExperimentWithExposureLoggingDisabled(experimentName).get(configKey, defaultValue);
        }
        catch (error) {
            // Log the first occurrence of the error
            if (!FeatureGates.hasGetExperimentCohortErrorOccurred) {
                console.warn({
                    msg: 'An error has occurred getting the experiment cohort. Only the first occurrence of this error is logged.',
                    experimentName,
                    defaultValue,
                    fireExperimentExposure,
                    error
                });
                FeatureGates.hasGetExperimentCohortErrorOccurred = true;
            }
            // Return a default value
            return new statsig_js_lite_1.DynamicConfig(experimentName, {}, '', {
                time: Date.now(),
                reason: statsig_js_lite_1.EvaluationReason.Error
            }).get('cohort', defaultValue);
        }
    }
    static getExperimentWithExposureLoggingDisabled(experimentName) {
        return statsig_js_lite_1.default.getExperimentWithExposureLoggingDisabled(experimentName);
    }
    static manuallyLogExperimentExposure(experimentName) {
        statsig_js_lite_1.default.manuallyLogExperimentExposure(experimentName);
    }
    static shutdownStatsig() {
        statsig_js_lite_1.default.shutdown();
    }
    /**
     * This method initializes the client using a network call to fetch the bootstrap values for the given user.
     *
     * @param clientOptions
     * @param identifiers
     * @param customAttributes
     * @private
     */
    static async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = Object.assign(Object.assign({}, clientOptions), { disableCurrentPageLogging: true });
        let experimentValues;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for the experiment
            // values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = fetcher_1.default.fetchClientSdk(clientOptions).then((value) => (fromValuesClientOptions.sdkKey = value.clientSdkKey));
            const experimentValuesPromise = fetcher_1.default.fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client with experiment
            // values if both requests are successful. Else an error would be thrown and handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
        }
        catch (error) {
            if (error instanceof Error) {
                console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            }
            console.warn(`Initialising Statsig client without values`);
            await FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes, experimentValues);
    }
    /**
     * This method initializes the client using a set of boostrap values obtained from one of the server-side SDKs.
     *
     * @param clientOptions
     * @param identifiers
     * @param customAttributes
     * @param initializeValues
     * @private
     */
    static async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const user = this.toStatsigUser(identifiers, customAttributes);
        FeatureGates.currentIdentifiers = identifiers;
        FeatureGates.currentAttributes = customAttributes;
        if (!clientOptions.sdkKey) {
            clientOptions.sdkKey = DEFAULT_CLIENT_KEY;
        }
        const { sdkKey } = clientOptions;
        const statsigOptions = this.toStatsigOptions(clientOptions, initializeValues);
        try {
            await statsig_js_lite_1.default.initialize(sdkKey, user, statsigOptions);
        }
        catch (error) {
            if (error instanceof Error) {
                console.error(`Error occurred when trying to initialise the Statsig client, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            }
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            await statsig_js_lite_1.default.initialize(DEFAULT_CLIENT_KEY, user, Object.assign(Object.assign({}, statsigOptions), { initializeValues: {} }));
            throw error;
        }
    }
    /**
     * This method creates an instance of StatsigUser from the given set of identifiers and attributes.
     *
     * @param identifiers
     * @param customAttributes
     * @private
     */
    static toStatsigUser(identifiers, customAttributes) {
        const user = {
            customIDs: identifiers,
            custom: customAttributes
        };
        if (identifiers.atlassianAccountId) {
            user.userID = identifiers.atlassianAccountId;
        }
        return user;
    }
    /**
     * This method updates the user for this client with the bootstrap values returned from a given Promise.
     *
     * @param identifiers
     * @param customAttributes
     * @param initializeValuesPromise
     * @private
     */
    static async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        if (!FeatureGates.initPromise) {
            throw new Error('The FeatureGates client must be initialized before you can update the user.');
        }
        // If the user isn't changing at all, then exit immediately
        if (FeatureGates.isCurrentUser(identifiers, customAttributes)) {
            return FeatureGates.initPromise;
        }
        // Wait for the current initialize/update to finish
        const originalInitPromise = FeatureGates.initPromise;
        try {
            await FeatureGates.initPromise;
        }
        catch (err) {
            // Proceed with the user update even if the init failed, since this update
            // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = FeatureGates.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this point.
        // Any subsequent calls to await FeatureGates.initialize() or FeatureGates.updateUser() will now also await this user update.
        FeatureGates.initPromise = updateUserPromise.catch(() => {
            // If the update failed then it changed nothing, so revert back to the original promise.
            FeatureGates.initPromise = originalInitPromise;
        });
        return updateUserPromise;
    }
    /**
     * This method updates the user on the nested Statsig client
     *
     * @param identifiers
     * @param customAttributes
     * @param initializeValuesPromise
     * @private
     */
    static async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        var _a, _b;
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            user = FeatureGates.toStatsigUser(identifiers, customAttributes);
        }
        catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            (_b = (_a = FeatureGates.initOptions).updateUserCompletionCallback) === null || _b === void 0 ? void 0 : _b.call(_a, false, errMsg);
            throw err;
        }
        const success = statsig_js_lite_1.default.updateUserWithValues(user, initializeValues);
        if (success) {
            FeatureGates.currentIdentifiers = identifiers;
            FeatureGates.currentAttributes = customAttributes;
        }
        else {
            throw new Error('Failed to update user. An unexpected error occured.');
        }
    }
    /**
     * This method transforms the options given by the user into the format accepted by the Statsig client.
     *
     * @param options
     * @private
     */
    static toStatsigOptions(options, initializeValues) {
        const { 
        // De-structured to remove from restClientOptions
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sdkKey, 
        // De-structured to remove from restClientOptions
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        products, 
        // De-structured to remove from restClientOptions
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        updateUserCompletionCallback } = options, restClientOptions = __rest(options, ["sdkKey", "products", "updateUserCompletionCallback"]);
        return Object.assign(Object.assign(Object.assign({}, restClientOptions), { initializeValues, environment: {
                tier: options.environment
            }, disableCurrentPageLogging: true }), (options.updateUserCompletionCallback && {
            updateUserCompletionCallback: FeatureGates.toStatsigUpdateUserCompletionCallback(options.updateUserCompletionCallback)
        }));
    }
    /**
     * This method transforms an UpdateUserCompletionCallback in our own format into the format accepted by the Statsig client.
     *
     * @param callback
     * @private
     */
    static toStatsigUpdateUserCompletionCallback(callback) {
        /**
         * The duration passed to the callback indicates how long the update took, but it is deceptive since it only times the
         * Statsig code and doesn't account for all of the extra custom work we do to obtain the bootstrap values.
         * As a result, we just suppress this parameter in our own callback rather than trying to keep it accurate.
         */
        return (_duration, success, message) => {
            callback(success, message);
        };
    }
    static isCurrentUser(identifiers, customAttributes) {
        return (FeatureGates.shallowEquals(FeatureGates.currentIdentifiers, identifiers) &&
            FeatureGates.shallowEquals(FeatureGates.currentAttributes, customAttributes));
    }
    static shallowEquals(objectA, objectB) {
        if (!objectA && !objectB) {
            return true;
        }
        if (!objectA || !objectB) {
            return false;
        }
        const aEntries = Object.entries(objectA);
        const bEntries = Object.entries(objectB);
        if (aEntries.length !== bEntries.length) {
            return false;
        }
        const ascendingKeyOrder = ([key1], [key2]) => key1.localeCompare(key2);
        aEntries.sort(ascendingKeyOrder);
        bEntries.sort(ascendingKeyOrder);
        for (let i = 0; i < aEntries.length; i++) {
            const [, aValue] = aEntries[i];
            const [, bValue] = bEntries[i];
            if (aValue !== bValue) {
                return false;
            }
        }
        return true;
    }
}
FeatureGates.initPromise = null;
FeatureGates.hasGetExperimentErrorOccurred = false;
FeatureGates.hasGetExperimentCohortErrorOccurred = false;
exports.default = FeatureGates;
